import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";
import toast from "components/ui/toast/Toast";
import { useDeleteSsoProvider } from "lib/hooks/api/auth/sso/useDeleteSsoProvider";

type Props = {
  open: boolean;
  onClose: () => void;
  providerId: string;
};

const BODY_ID = "delete-sso-provider-modal-body";

export function DeleteSsoProviderModal({ open, onClose, providerId }: Props) {
  const { mutate: deleteProvider, isLoading: isDeleting } = useDeleteSsoProvider({
    onSuccess: () => {
      toast.success("SSO provider deleted");
      onClose();
    },
    onError: () => {
      toast.error("Could not delete SSO provider. Please try again.");
    },
  });

  return (
    <Modal
      open={open}
      onOpenChange={onClose}
      maxWidth="400px"
      showCloseButton={false}
      aria-describedby={BODY_ID}
      padding={24}
    >
      <Flex column gap={24}>
        <Flex column gap={8}>
          <Text h2>Delete SSO provider</Text>
          <Text id={BODY_ID}>
            Are you sure you want to delete this SSO provider? Users who sign in via this provider
            will no longer be able to authenticate with SSO.
          </Text>
        </Flex>
        <Flex justifyContent="flex-end" gap={8}>
          <Button buttonStyle="inverse" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button
            buttonStyle="destructive"
            onClick={() => deleteProvider({ providerId })}
            disabled={isDeleting}
            loading={isDeleting}
          >
            Delete
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
